import React from 'react';
import './about.css';

const TwoSectionLayout = () => {
  return (
    <div
      className="two-section-wrapper"
      style={{
        backgroundImage: `url('/images/about-image/background1.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '80px 40px',
      }}
    >
      <div className="container">
        
        <div className="left-container">
          <div className="image-wrapper">
            <img src="/images/about-image/left1.jpeg" alt="Left" className="image" />
            <div className="overlay-text">
               <p>ARTWORK&nbsp;&nbsp;&nbsp; <b>DECEMBER10</b></p>
              <h4>
		Celebrating the timeless melodies and cinematic impact of Lata Mangeshkar.	</h4>
             
              <a href="#about">Learn More</a>
            </div>
          </div>
        </div>

        
        <div className="right-container">
          <img src="/images/about-image/right1.jpeg" alt="Right" className="image1" />
          <div className="below-text">
            <p>ARTWORK&nbsp;&nbsp;&nbsp; <b>JULY25</b></p>
            <h2>
		A glimpse into the mind behind the lens	</h2>
            <a href="#about">Learn More</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoSectionLayout;
